var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gauge-wrap",class:{ 'label-top': _vm.labelTop }},[(_vm.labelTop && _vm.detailMode !== 'billet')?_c('div',{staticClass:"label"},[_c('span',[_vm._v(_vm._s(_vm.label))]),_vm._t("label-extra")],2):_vm._e(),_c('div',{staticClass:"gauge-chart",attrs:{"id":_vm.chartId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }